import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { MediaIconComponent } from './media-icon.component';
import { MediaThumbComponent } from './media-thumb.component';
import { publishedTiles, Tile } from './media-tiles';

/**
 * «Как увидит покупатель» (the board AdmMediaEditor): the main one big as the page of the cake shows it, the thumbnails under it, and the little picture of the catalog, the cart,
 * the orders, the app and the old site, which all show the main one. It shows only what the buyer sees: the PUBLISHED tiles (an item with files in the public bucket; a re-crop
 * in progress of a published item still counts, its old files stay). A file that is still going up or being processed, or that failed, is not there. With nothing published,
 * the old photo is what they show.
 */
@Component({
  selector: 'hc-media-preview-card',
  imports: [TranslocoDirective, MediaIconComponent, MediaThumbComponent],
  templateUrl: './media-preview-card.component.html',
  styleUrls: ['./media-preview-card.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MediaPreviewCardComponent {
  /** Every tile of the grid; the card picks the ones the buyer can see. */
  readonly tiles = input.required<readonly Tile[]>();
  /** The old photo of the size, shown while there is no tile. */
  readonly legacyUrl = input<string | null>(null);

  protected readonly legacyBroken = signal(false);
  protected readonly published = computed<Tile[]>(() => publishedTiles(this.tiles()));
  protected readonly main = computed<Tile | null>(() => this.published()[0] ?? null);
  /** The first tile of the grid wears «Главное», but the buyer does not see it yet: it is still going up or being processed. */
  protected readonly mainWaits = computed(() => {
    const first = this.tiles()[0];
    return !!first && first.maxWidth == null && first.state !== 'failed' && first.state !== 'interrupted';
  });
  protected readonly mainIsVideo = computed(() => this.main()?.kind === 'VIDEO');
}
